import { getNativeConfig } from 'src/config/brandings/toll/nativeConfig.ts'

module.exports = () => {
  return {
    styles: {
      load: () => import(/* webpackChunkName: "styleTOLL" */'src/config/brandings/toll/index.scss')
    },
    meta: {
      meta: [
        { name: 'apple-itunes-app', content: 'app-id=6447463497' },
        { name: 'og:image', content: '/favicons/favicon_192x192.png' },
        { name: 'twitter:image', content: '/favicons/favicon_192x192.png' }
      ],
      link: [
        { rel: 'shortcut icon', href: '/brandings/toll/favicons/favicon-16x16.png', type: 'image/png' }
      ]
    },
    logos: {
      logo: 'brandings/toll/logo/toll-logo.svg'
    },
    search: {
      queries: {
        branding: 'TOLL'
      }
    },
    start: {
      description: 'branding.toll.start.description',
      image: false,
      show_more: false,
      sdui_authenticator: false
    },
    management: {
      show_announcements: true,
      show_material_page: true,
      additional_content: {
        infos: 'branding.toll.management.additional_content.infos'
      }
    },
    ui: {
      show_hint_cards: true,
      show_video_hint: true
    },
    settings: {
      notifications: {
        email_newsletter: false
      }
    },
    dataProtection: {
      show_go_to_sdui_website: false
    },
    onboarding: {
      help_videos: true
    },
    keepAlivePing: false,
    appSwitcher: {
      show_marketing: false
    },
    login: {
      registration_code: true,
      hideSduiLoginDefault: false,
      sduiLoginDefaultExpanded: false,
      form: {
        inline_reset_password: true
      }
    },
    ...getNativeConfig()
  }
}
